import { getMetricLenderViewsByCriteria } from '@nemuru-eng/js-api-client';

import { useCache } from '@/hooks/requests/useCache';

export const useGetMetricLenderViewsByCriteria = (query: string) => {
  const { data, loading, error, revalidate } = useCache(getMetricLenderViewsByCriteria, { query });

  return {
    metricLenderViews: data,
    metricLenderViewsLoading: loading,
    metricLenderViewsError: error,
    revalidateMetricLenderViews: revalidate,
  };
};
